var $2f00170f4ee3ca01$exports = {};
$2f00170f4ee3ca01$exports = {
  "removeButtonLabel": "Eemalda",
  "removeDescription": "Sildi eemaldamiseks vajutage kustutusklahvi Delete."
};
export { $2f00170f4ee3ca01$exports as default };